import { render, staticRenderFns } from "./EventBus.vue?vue&type=template&id=1278b523&"
import script from "./EventBus.vue?vue&type=script&lang=js&"
export * from "./EventBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports